import { render } from "./P097.vue?vue&type=template&id=ddb2a9ee&scoped=true"
import script from "./P097.vue?vue&type=script&lang=js"
export * from "./P097.vue?vue&type=script&lang=js"

import "./P097.vue?vue&type=style&index=0&id=ddb2a9ee&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddb2a9ee"]])

export default __exports__